/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
	fetch({ commit }) {
		commit('FETCH_TRANSACTION_TYPES')
		console.log('fetch transaction types');
		return new Promise((resolve, reject) => {
			axios.get("/api/transaction-types/list")
				.then((response) => {
					console.log('set transaction types');
					commit('SET_TRANSACTION_TYPES', response.data)
					resolve(response)
				})
				.catch((error) => { reject(error) })
		})
	},
	save({ commit }, item) {
		console.log('postdata', item);
		return new Promise((resolve, reject) => {
			axios.post('/api/transaction-types/create', item)
				.then((response) => {
					console.log(response.data);
					resolve(response)
				})
				.catch((error) => { reject(error) })
		})
	},
	update({ commit }, item) {
		return new Promise((resolve, reject) => {
			axios.post('/api/transaction-types/update/' + item.id, item)
				.then((response) => {
					console.log(response.data);
					resolve(response)
				})
				.catch((error) => { reject(error) })
		})
	},
	delete({ commit }, id) {
		return new Promise((resolve, reject) => {
			axios.delete(`/api/transaction-types/delete/${id}`)
				.then((response) => {
					resolve(response)
				})
				.catch((error) => { reject(error) })
		})
	},
}
